import a from "./value.js";
function c(i, n) {
  n === void 0 && (n = i, i = a);
  for (var t = 0, r = n.length - 1, f = n[0], e = new Array(r < 0 ? 0 : r); t < r; ) e[t] = i(f, f = n[++t]);
  return function(o) {
    var h = Math.max(0, Math.min(r - 1, Math.floor(o *= r)));
    return e[h](o - h);
  };
}
export {
  c as default
};
